import usePageOfTaskRoleOptions from './usePageOfTaskRoleOptions';
import usePageOfTaskResourceRoleOptions from './usePageOfTaskResourceRoleOptions';

const useAllRoleOptionsQuery = ({
  variant,
  taskUri,
  userUri,
  page,
  pageSize,
  textSearch
}) => {
  const isTask = variant === 'taskRole';

  const taskResult = usePageOfTaskRoleOptions({
    taskUri,
    page,
    pageSize,
    textSearch,
    skip: !isTask
  });

  const resourceResult = usePageOfTaskResourceRoleOptions({
    taskUri,
    userUri,
    page,
    pageSize,
    textSearch,
    skip: isTask
  });

  return isTask ? taskResult : resourceResult;
};

export default useAllRoleOptionsQuery;
